import type { SitePaymentTerms, SitePrice } from '@telify/shared';

import { paymentTermsText } from '../../format';

/** The terms line, as the prototype words it: a free offering is free to book; a paid one held for approval is charged after it. */
export function termsText(payment: SitePaymentTerms, price: SitePrice, requiresApproval: boolean): string | null {
  const paid = payment.paymentRequirement !== 'NONE' && price.kind !== 'FREE' && price.amount != null;
  if (!paid) return 'Free to book';
  const text = paymentTermsText(payment, paid, price.amount);
  return requiresApproval && payment.paymentRequirement === 'FULL_PAYMENT' && text ? 'Paid online after approval' : text;
}
